import React from "react";
import countries from "i18n-iso-countries";
import DateFnsUtils from "@date-io/date-fns";
import de from "i18n-iso-countries/langs/de.json";
import en from "i18n-iso-countries/langs/en.json";

import { AppRouter } from "./AppRouter";
import { GraphQLProvider } from "common/components/GraphQLProvider";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Provider } from "react-redux";
import { RootStore } from "./common/store/index";
import { theme } from "./theme";
import { ThemeProvider } from "@material-ui/core";

import "./App.css";
import "./common/services/i18n";

import "./assets/styles/Global.scss";

countries.registerLocale(en);
countries.registerLocale(de);

function App() {
  return (
    <Provider store={RootStore}>
      <GraphQLProvider>
        <ThemeProvider theme={theme}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <div className="App">
              <AppRouter />
            </div>
          </MuiPickersUtilsProvider>
        </ThemeProvider>
      </GraphQLProvider>
    </Provider>
  );
}

export default App;
